<main>
  <div>
    <div>
      @if (wsService.connected | async) {
        <span>Connected</span>
      }
      @if ((wsService.connected | async) === false) {
        <span>Disconnected</span>
      }
    </div>

    <button mat-button (click)="send()" [disabled]="(wsService.connected | async) === false">Send hello</button>
    @if (message) {
      <div>Message from server: {{ message }}</div>
    }
  </div>
</main>
